export const source = 'vdp';

export const enum VdpDispatcherEvent {
  IsFavorite = 'is_favorite',
  ToggleChatUi = 'toggle_chat_ui'
}
